import { Component, OnInit } from '@angular/core';
import { CartTotalStepComponent } from 'gung-standard';

@Component({
    selector: 'colmec-cart-total-step',
    templateUrl: './colmec-cart-total-step.component.html',
    styleUrls: ['./colmec-cart-total-step.component.scss'],
    standalone: false
})
export class ColmecCartTotalStepComponent extends CartTotalStepComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.onNextBtnClicked.subscribe(_ => this.stepDone.emit(this.checkout));
  }
}
